<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="equipamentos"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="filtrosAtivos"
          ></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            v-if="perms.includes('equipamento.criar_equipamento_medicao')"
            depressed
            color="accent"
            @click="novo()"
          >
            <v-icon class="mdi mdi-plus mr-2" />Novo Cadastro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.ativo="{ item }">
        <v-icon
          :class="
            item.ativo
              ? 'mdi mdi-checkbox-marked-outline'
              : 'mdi mdi-checkbox-blank-outline'
          "
        />
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          v-if="perms.includes('equipamento.criar_equipamento_medicao')"
          icon
          small
          text
          @click="editar(item)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          v-if="perms.includes('equipamento.excluir_equipamento_medicao')"
          titulo="Deletar equipamento de medição"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
    <v-dialog width="500" persistent v-model="dialog">
      <v-card v-if="dialog" :loading="loadingDialog">
        <v-card-title>
          {{
            termoAtivo.id !== ""
              ? "Editar equipamento p/ medição"
              : "Novo equipamento p/ medição"
          }}
          <v-spacer />
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="termoAtivo.titulo"
            label="Código"
            counter="50"
            maxlength="50"
          />
          <v-textarea
            v-model="termoAtivo.descricao"
            auto-grow
            rows="2"
            label="Descrição"
            counter="140"
            maxlength="140"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialog = false">CANCELAR</v-btn>
          <v-btn
            color="primary"
            depressed
            @click="salvar()"
            :loading="loadingDialog"
            :disabled="invalido"
            >SALVAR</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import DatatableFilters from "../components/DatatableFilters";
import DialogConfirm from "../components/DialogConfirm";
import _ from "lodash";

const modelo = {
  id: "",
  titulo: "",
  descricao: "",
};

export default {
  components: { DatatableFilters, DialogConfirm },
  data() {
    return {
      headers: [
        { text: "Código", value: "titulo" },
        { text: "Descrição", value: "descricao" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      filters: [
        {
          name: "titulo",
          label: "Código",
          type: "text",
          defaultValue: "",
        },
        {
          name: "descricao",
          label: "Descrição",
          type: "text",
          defaultValue: "",
        },
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.equipamentos-medicao") || "{}"
      ),
      loading: false,
      loadingDialog: false,
      dialogConfirm: false,
      termoAtivo: null,
    };
  },
  computed: {
    equipamentos() {
      return this.$store.state.taxonomia.termos;
    },
    dialog: {
      get() {
        return this.termoAtivo !== null;
      },
      set(val) {
        if (!val) {
          this.termoAtivo = null;
        }
      },
    },
    invalido() {
      return this.termoAtivo.titulo === "" || this.termoAtivo.descricao === "";
    },
    perms() {
      return this.$store.state.usuarios.usuarioAtivo.permissoes;
    },
  },
  methods: {
    async deletar(id) {
      this.loading = true;
      try {
        await this.$store.dispatch("taxonomia/deletarTermo", {
          dicionario: "equipamentos_medicao",
          id,
        });
        this.listar();
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível excluir o equipamento para medição",
        });
        this.loading = false;
      }
    },
    editar(termo) {
      this.termoAtivo = _.cloneDeep(termo);
    },
    async listar() {
      this.loading = true;
      try {
        await this.$store.dispatch("taxonomia/listarTermos", {
          dicionario: "equipamentos_medicao",
          opcoes: this.filtrosAtivos,
        });
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    novo() {
      this.termoAtivo = _.clone(modelo);
    },
    async salvar() {
      if (this.invalido) {
        return;
      }
      this.loadingDialog = true;
      try {
        await this.$store.dispatch("taxonomia/salvarTermo", {
          dicionario: "equipamentos_medicao",
          termo: this.termoAtivo,
        });
        this.dialog = false;
        this.listar();
      } catch (err) {
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível gravar o equipamento para medição",
        });
      }
      this.loadingDialog = false;
    },
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.equipamentos-medicao", JSON.stringify(val));
      this.listar();
    },
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de equipamentos p/ medição",
    });
    this.listar();
  },
};
</script>
